module.exports = __webpack_public_path__ + "img/screenshot-1.62af0842.webp";